// extracted by mini-css-extract-plugin
export default {"recaptcha":"ReCAPTCHAWrapper_recaptcha__8zoSC"};